import { copyHotspotsFromUrl, setCurrentlyOpenModal } from "../../redux";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentlyOpenModal } from "../../redux/selectors";
import { Button, Form, Input, Modal } from "antd";
import { modals } from "../../util/constants";
import { useState } from "react";
import { validateSirvUrl } from "../../util/validateSirvUrl";

export function ImportModal() {
  const [form] = Form.useForm();
  const [disabled, setDisabled] = useState(true);
  const currentlyOpenModal = useSelector(getCurrentlyOpenModal);
  const dispatch = useDispatch();

  const handleFormChange = () => {
    const hasErrors = form.getFieldsError().some(({ errors }) => errors.length);
    setDisabled(hasErrors);
  };

  const handleClose = () => {
    dispatch(setCurrentlyOpenModal(""));
  };

  const onFinish = (values) => {
    const { url } = values;
    dispatch(copyHotspotsFromUrl(url));
  };

  const onFinishFailed = (errorInfo) => {
    // Handle form validation failure (should never happen)
    console.error("Import hotspots URL validation error:", errorInfo);
  };

  return (
    <Modal
      open={currentlyOpenModal === modals.import}
      onCancel={handleClose}
      onOk={copyHotspotsFromUrl}
      footer={null}
      title="Import hotspots"
      centered={true}
    >
      <Form
        name="ImportHotspotsForm"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        requiredMark={false} // Hides the red asterisk
        layout="vertical"
        onFieldsChange={handleFormChange}
        form={form}
      >
        <Form.Item>
          Copy the hotspots, content and styles from another spin. If the spins
          have a different number of frames, the hotspot locations won't be
          copied.
        </Form.Item>
        <Form.Item
          name="url"
          label="Spin URL"
          rules={[
            {
              validator: validateSirvUrl, // Custom validation rule
            },
          ]}
          colon={false} // Removes the colon after the label
        >
          <Input
            spellCheck={false}
            allowClear
            placeholder="https://your-account.sirv.com/example/example.spin"
          />
        </Form.Item>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "9px",
          }}
        >
          <Form.Item>
            <Button key="ok" onClick={handleClose} type="text" autoFocus>
              Cancel
            </Button>
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" disabled={disabled}>
              Import
            </Button>
          </Form.Item>
        </div>
      </Form>
    </Modal>
  );
}
